<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import CustomHtml from "../CustomHTML.svelte";
  import { createSystemRoutes } from "../../lib/routing";
  import { settingsStore } from "../../lib/stores/settings";
  import { get } from "svelte/store";
  import Youtube from "../Youtube.svelte";

  export let currentRoute;

  const getCopyRoute = (currentRoute: { name: string; path: string }) => {
    const systemRoutes = createSystemRoutes(get(settingsStore));
    const data = systemRoutes.find(({ path }) => {
      return path === currentRoute.path;
    });
    return data?.id;
  };

  $: copyRoute = getCopyRoute(currentRoute) as string;
  $: copy = $getCopy(copyRoute) as Record<string, string>;
</script>

<BaseStep {currentRoute}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />

    <div class="mt-8">
      <CustomHtml customHtml={copy.customHtml} />
      <Youtube videoId={copy.videoId} />
    </div>
  </svelte:fragment>
</BaseStep>
